var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.appcontent.data,"server-items-length":_vm.appcontent.meta.total,"options":_vm.options,"sort-by":"name"},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.type_id",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.type))]}},{key:"item.category_id",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.category))]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('action-slot-component',{attrs:{"item":item,"route-name":"forms.show","route-params":{ id: item.id }},on:{"show":function($event){return _vm.$emit('show', item)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }